import React                    from 'react';
import { connect }              from 'react-redux';
import { Dispatch }             from "redux";
import { reducerType }          from 'reducer';
import { ActionTypes }          from 'actions/types';
import eggLogo1                 from 'images/eggLogo1.png';
import eggLogo2                 from 'images/eggLogo2.jpg';
import handleNavigate           from 'functions/handleNavigate';
import words                    from 'utils/words';
import { makeStyles }           from "makeStyles";
import { componentsStateType }  from 'reducer/types';
import { SET_COMPONENTS_STATE } from 'actions';

var clsx = require('classnames')

const useStyles = makeStyles()(
    () => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
        flexFlow:        'column',
        overflow:        'hidden',
        transition:      'opacity 0.8s',
    },
    row1: {
        minHeight:       '50vh',
        minWidth:        '100vw',
        maxHeight:       '50vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
    },
    row2: {
        minHeight:       '50vh',
        minWidth:        '100vw',
        maxHeight:       '50vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
    },
    item: {
        flex:           1,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        width:          '100%',
        height:         '50vh',
    },
    bigItem: {
        flex:           1,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        width:          '100%',
        height:         '50vh',

    },
    smallItem: {
        flex:           0.3,
        flexFlow:       'column',
        justifyContent: 'flex-start',

    },
    title: {
       flexFlow: 'column',

    },
    bigFont: {
        fontSize:   38,
        fontWeight: 'bold'
    },
    smallFont: {
        fontSize: 34,
    },
    icon: {
        backgroundSize:     'contain',
        backgroundPosition: 'center',
        backgroundRepeat:   'no-repeat',
    },
    icon1: {
        width:           '90%',
        height:          '90%',
        backgroundImage: `url(${ eggLogo1 })`,
    },
    icon2: {
        width:           '90%',
        height:          '90%',
        backgroundImage: `url(${ eggLogo2 })`,
    },
    pageIcon: {
        width:  '100%',
        height: '50%',
    },
    inner: {
        width:          '90%',
        height:         '90%',
        display:        'flex',
        flexFlow:       'column',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        border:         '1px solid #DDD',
        borderRadius:   '1em',
        cursor:         'pointer',
        fontSize:       25,
        '&:hover': {
            backgroundColor: '#EEF'
        }
    },
    name: {
        width:          '90%',
        height:         '30%',
        display:        'flex',
        flexFlow:       'column',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
    },
    smalltext: {
       fontSize: 18
    }
}))

type HomeProps = {
    wideScreen:         boolean;
    componentsState:    componentsStateType;
    setComponentsState: (val: componentsStateType) => void;
}

const Home: React.FC<HomeProps> = ({ wideScreen, componentsState, setComponentsState }) => {

  const  { classes } = useStyles();


  return (
     <div className = { classes.root }>
        <div className = { classes.row1 }> 
           <div className = { clsx(classes.item, classes.smallItem) }> 
              <div className = { clsx(classes.icon, classes.icon1) }/>
           </div>
           <div 
              dir       = 'rtl'
              className = { clsx(classes.item, classes.bigItem, classes.title) }
           > 
              <div className  =  { classes.bigFont }>זיהוי מספרים בתחום המאה</div>
              <div className = { classes.smallFont }>תבניות הביצים</div>
           </div>
           <div className = { clsx(classes.item, classes.smallItem) }> 
              <div className = { clsx(classes.icon, classes.icon2) }/>  
           </div>
        </div>
        <div className = { classes.row2 }>
        {
            ['tirgul', 'mazeget'].map((val, ind) => {
                return (
                    <div
                      key       = { `page_:^^${ ind }` }
                      className = { classes.bigItem }
                      style     = {{
                        fontSize: wideScreen ? 24 : 18,
                      }}
                    >
                        <div 
                           className = { classes.inner }
                           onClick   = { () => { handleNavigate(val) }}
                        >
                           
                           <div className = { wideScreen ? classes.name : clsx(classes.name, classes.smalltext) }>
                             {/* { 
                                (ind === 1 || ind === 2)
                                &&
                                <div dir = 'rtl'>
                                    { `חיבור:` }
                                </div>
                             }  */}
                             <div dir = 'rtl'>
                                    { words[`${ val }`] }
                             </div>
                           </div>
                           {/* <div
                              className = { clsx(classes.icon, classes.pageIcon) }
                              style     = {{
                                  backgroundImage: `url(${ val.icon })`
                              }}
                           /> */}
                        </div>
                    </div>
                )
            })
        }
        </div>
     </div>
  );
}



const mapStateToProps = (reducer: reducerType) => {
    return {
      componentsState: reducer.components,
  }};
    
  const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
      setComponentsState: (payload: componentsStateType) => dispatch(SET_COMPONENTS_STATE(payload)),
  });
    
  export default connect(mapStateToProps,mapDispatchToProps)(Home);
    
    
    